import React from "react";
import { Controller } from "react-hook-form";
import { Box } from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import enGB from "date-fns/locale/en-GB";
import de from "date-fns/locale/de";
import fr from "date-fns/locale/fr";

import dayjs from "dayjs";

function getDateFnsLocale(languageId) {
    switch (languageId) {
        case 1: // anglais
            return enGB;
        case 2: // allemand
            return de;
        case 3: // français
            return fr;
        default:
            return enGB;
    }
}

function FormDateInput({
                           name,
                           control,
                           label,
                           defaultValue,
                           disabled = false,
                           sx = {},
                           languageId,
                       }) {
    const dateFnsLocale = getDateFnsLocale(languageId);

    return (
        <Box
            sx={{
                flex: 1,
                ...sx,
            }}
        >
            <Controller
                name={name}
                control={control}
                defaultValue={defaultValue}
                render={({ field: { onChange, value }, fieldState: { error } }) => (
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={dateFnsLocale}
                    >
                        <DatePicker
                            helperText={error ? error.message : null}
                            error={!!error}
                            value={value ? dayjs(value).toDate() : null}
                            onChange={(newDate) =>
                                onChange(newDate ? dayjs(newDate).format("YYYY-MM-DD") : null)
                            }
                            format={"dd.MM.yyyy"}
                            label={label}
                            disabled={disabled}
                            sx={{ width: "100%" }}
                        />
                    </LocalizationProvider>
                )}
            />
        </Box>
    );
}

export { FormDateInput };
export default FormDateInput;
